/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../Fixes';
import Builder from '../../Builder';
import '../common/currency';
import '../common/location';
import '../common/countries';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "timecards": {
        "nested": {
          "Timecard": {
            "fields": {
              "token": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              },
              "shiftId": {
                "type": "string",
                "id": 17,
                "rule": "optional"
              },
              "merchantToken": {
                "type": "string",
                "id": 12,
                "rule": "optional"
              },
              "employeeToken": {
                "type": "string",
                "id": 2,
                "rule": "optional"
              },
              "employee": {
                "type": "squareup.timecards.Employee",
                "id": 11,
                "rule": "optional"
              },
              "clockinUnitToken": {
                "type": "string",
                "id": 5,
                "rule": "optional"
              },
              "clockoutUnitToken": {
                "type": "string",
                "id": 6,
                "rule": "optional"
              },
              "deleted": {
                "type": "bool",
                "id": 7,
                "rule": "optional"
              },
              "clockinTimestampMs": {
                "type": "int64",
                "id": 8,
                "rule": "optional"
              },
              "clockoutTimestampMs": {
                "type": "int64",
                "id": 9,
                "rule": "optional"
              },
              "hourlyWage": {
                "type": "squareup.common.Money",
                "id": 10,
                "rule": "optional"
              },
              "employeeJobInfo": {
                "type": "squareup.timecards.EmployeeJobInfo",
                "id": 15,
                "rule": "optional"
              },
              "createdAtTimestampMs": {
                "type": "uint64",
                "id": 13,
                "rule": "optional"
              },
              "updatedAtTimestampMs": {
                "type": "uint64",
                "id": 14,
                "rule": "optional"
              },
              "note": {
                "type": "string",
                "id": 16,
                "rule": "optional"
              },
              "declaredTip": {
                "type": "squareup.common.Money",
                "id": 18,
                "rule": "optional"
              },
              "wasAutomaticallyClockedOut": {
                "type": "bool",
                "id": 19,
                "rule": "optional"
              }
            }
          },
          "TimecardEvent": {
            "fields": {
              "token": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              },
              "transactionToken": {
                "type": "string",
                "id": 6,
                "rule": "optional"
              },
              "creatorEmployeeToken": {
                "type": "string",
                "id": 3,
                "rule": "optional"
              },
              "eventType": {
                "type": "squareup.timecards.TimecardEvent.EventType",
                "id": 4,
                "rule": "optional"
              },
              "pointInTimeTimecard": {
                "type": "squareup.timecards.Timecard",
                "id": 5,
                "rule": "optional"
              }
            },
            "nested": {
              "EventType": {
                "values": {
                  "CLOCKIN": 1,
                  "CLOCKOUT": 2,
                  "SUPERVISOR_CLOSE": 3,
                  "EDIT": 4,
                  "CREATE": 5,
                  "DELETE": 6,
                  "API_CREATE": 7,
                  "API_DELETE": 8,
                  "API_EDIT": 9,
                  "UPDATE_NOTE": 10,
                  "AUTO_CLOCK_OUT": 11,
                  "LARGE_TIMECARD_SPLIT_EDIT": 12,
                  "LARGE_TIMECARD_SPLIT_CREATE": 13,
                  "EDIT_REQUEST_EDIT": 14,
                  "UPDATE_CASH_TIPS": 15
                }
              }
            }
          },
          "TimecardBreak": {
            "fields": {
              "token": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              },
              "timecardToken": {
                "type": "string",
                "id": 2,
                "rule": "optional"
              },
              "merchantToken": {
                "type": "string",
                "id": 3,
                "rule": "optional"
              },
              "startTimestampMs": {
                "type": "int64",
                "id": 4,
                "rule": "optional"
              },
              "stopTimestampMs": {
                "type": "int64",
                "id": 5,
                "rule": "optional"
              },
              "timecardBreakDefinitionToken": {
                "type": "string",
                "id": 6,
                "rule": "optional"
              },
              "isPaid": {
                "type": "bool",
                "id": 7,
                "rule": "optional"
              },
              "breakName": {
                "type": "string",
                "id": 8,
                "rule": "optional"
              },
              "expectedDurationSeconds": {
                "type": "uint32",
                "id": 9,
                "rule": "optional"
              },
              "startTimestampSeconds": {
                "type": "int64",
                "id": 10,
                "rule": "optional"
              },
              "stopTimestampSeconds": {
                "type": "int64",
                "id": 11,
                "rule": "optional"
              },
              "violatesExpectedDuration": {
                "type": "bool",
                "id": 12,
                "rule": "optional"
              },
              "minimumDurationSeconds": {
                "type": "uint32",
                "id": 13,
                "rule": "optional"
              },
              "createdAt": {
                "type": "string",
                "id": 14,
                "rule": "optional"
              },
              "updatedAt": {
                "type": "string",
                "id": 15,
                "rule": "optional"
              }
            }
          },
          "TimecardAndBreaks": {
            "fields": {
              "timecard": {
                "type": "squareup.timecards.Timecard",
                "id": 1,
                "rule": "optional"
              },
              "breaks": {
                "type": "squareup.timecards.TimecardBreak",
                "id": 2,
                "rule": "repeated"
              }
            }
          },
          "TimecardBreakEvent": {
            "fields": {
              "token": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              },
              "transactionToken": {
                "type": "string",
                "id": 12,
                "rule": "optional"
              },
              "merchantToken": {
                "type": "string",
                "id": 2,
                "rule": "optional"
              },
              "breakToken": {
                "type": "string",
                "id": 3,
                "rule": "optional"
              },
              "creatorEmployeeToken": {
                "type": "string",
                "id": 4,
                "rule": "optional"
              },
              "eventType": {
                "type": "squareup.timecards.TimecardBreakEvent.EventType",
                "id": 5,
                "rule": "optional"
              },
              "startTimestampMs": {
                "type": "int64",
                "id": 6,
                "rule": "optional"
              },
              "stopTimestampMs": {
                "type": "int64",
                "id": 7,
                "rule": "optional"
              },
              "timecardBreakDefinitionToken": {
                "type": "string",
                "id": 8,
                "rule": "optional"
              },
              "isPaid": {
                "type": "bool",
                "id": 9,
                "rule": "optional"
              },
              "breakName": {
                "type": "string",
                "id": 10,
                "rule": "optional"
              },
              "expectedDurationSeconds": {
                "type": "uint32",
                "id": 11,
                "rule": "optional"
              }
            },
            "nested": {
              "EventType": {
                "values": {
                  "START_BREAK": 1,
                  "END_BREAK": 2,
                  "SUPERVISOR_CLOSE": 3,
                  "CREATE": 4,
                  "DELETE": 5,
                  "EDIT": 6,
                  "API_CREATE": 7,
                  "API_DELETE": 8,
                  "API_EDIT": 9,
                  "AUTO_CLOCK_OUT": 10,
                  "LARGE_TIMECARD_SPLIT_EDIT": 12,
                  "LARGE_TIMECARD_SPLIT_CREATE": 13,
                  "LARGE_TIMECARD_SPLIT_DELETE_MOVE": 14,
                  "EDIT_REQUEST_CREATE": 15,
                  "EDIT_REQUEST_EDIT": 16,
                  "EDIT_REQUEST_DELETE": 17
                }
              }
            }
          },
          "TimecardTransaction": {
            "fields": {
              "token": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              },
              "merchantToken": {
                "type": "string",
                "id": 2,
                "rule": "optional"
              },
              "timecardToken": {
                "type": "string",
                "id": 3,
                "rule": "optional"
              },
              "creatorEmployeeToken": {
                "type": "string",
                "id": 4,
                "rule": "optional"
              },
              "actingEmployeeToken": {
                "type": "string",
                "id": 5,
                "rule": "optional"
              },
              "actingTeamMember": {
                "type": "squareup.timecards.TimecardTransaction.TeamMember",
                "id": 8,
                "rule": "optional"
              },
              "createdAtTimestampMs": {
                "type": "int64",
                "id": 6,
                "rule": "optional"
              },
              "geoLocation": {
                "type": "squareup.common.location.GeoLocation",
                "id": 7,
                "rule": "optional"
              },
              "changeProposalToken": {
                "type": "string",
                "id": 10,
                "rule": "optional"
              }
            },
            "nested": {
              "TeamMember": {
                "fields": {
                  "id": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "givenName": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "familyName": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  }
                }
              }
            }
          },
          "TimecardTransactionWithEvents": {
            "fields": {
              "timecardTransaction": {
                "type": "squareup.timecards.TimecardTransaction",
                "id": 1,
                "rule": "optional"
              },
              "timecardEvent": {
                "type": "squareup.timecards.TimecardEvent",
                "id": 2,
                "rule": "optional"
              },
              "timecardBreakEvent": {
                "type": "squareup.timecards.TimecardBreakEvent",
                "id": 3,
                "rule": "repeated"
              }
            }
          },
          "TimecardBreakDefinition": {
            "fields": {
              "token": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              },
              "merchantToken": {
                "type": "string",
                "id": 2,
                "rule": "optional"
              },
              "unitToken": {
                "type": "string",
                "id": 3,
                "rule": "optional"
              },
              "breakName": {
                "type": "string",
                "id": 4,
                "rule": "optional"
              },
              "expectedDurationSeconds": {
                "type": "uint32",
                "id": 5,
                "rule": "optional"
              },
              "isPaid": {
                "type": "bool",
                "id": 6,
                "rule": "optional"
              },
              "enabled": {
                "type": "bool",
                "id": 7,
                "rule": "optional"
              },
              "updatedAtTimestampMs": {
                "type": "int64",
                "id": 8,
                "rule": "optional"
              },
              "updatedAtTimestampSeconds": {
                "type": "int64",
                "id": 9,
                "rule": "optional"
              },
              "createdAt": {
                "type": "string",
                "id": 10,
                "rule": "optional"
              },
              "updatedAt": {
                "type": "string",
                "id": 11,
                "rule": "optional"
              }
            }
          },
          "EmployeeJobInfo": {
            "fields": {
              "jobToken": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              },
              "jobTitle": {
                "type": "string",
                "id": 2,
                "rule": "optional"
              },
              "hourlyWage": {
                "type": "squareup.common.Money",
                "id": 3,
                "rule": "optional"
              },
              "isTipEligible": {
                "type": "bool",
                "id": 4,
                "rule": "optional",
                "options": {
                  "default": true
                }
              },
              "hoursWorkedPerWeek": {
                "type": "uint32",
                "id": 5,
                "rule": "optional"
              }
            }
          },
          "MerchantUnit": {
            "fields": {
              "merchantToken": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              },
              "unitToken": {
                "type": "string",
                "id": 2,
                "rule": "optional"
              },
              "tzName": {
                "type": "string",
                "id": 3,
                "rule": "optional"
              },
              "stateProvince": {
                "type": "string",
                "id": 4,
                "rule": "optional"
              },
              "country": {
                "type": "squareup.common.countries.Country",
                "id": 5,
                "rule": "optional"
              }
            }
          },
          "Employee": {
            "fields": {
              "employeeToken": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              },
              "firstName": {
                "type": "string",
                "id": 2,
                "rule": "optional"
              },
              "lastName": {
                "type": "string",
                "id": 3,
                "rule": "optional"
              },
              "employeeRole": {
                "type": "squareup.timecards.EmployeeRole",
                "id": 4,
                "rule": "optional"
              },
              "employeeNumber": {
                "type": "string",
                "id": 5,
                "rule": "optional"
              }
            }
          },
          "EmployeeRole": {
            "fields": {
              "employeeRoleToken": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              },
              "name": {
                "type": "string",
                "id": 2,
                "rule": "optional"
              },
              "isAccountOwnerRole": {
                "type": "bool",
                "id": 3,
                "rule": "optional"
              },
              "isOwnerRole": {
                "type": "bool",
                "id": 4,
                "rule": "optional"
              }
            }
          },
          "MerchantTimecardAuthorization": {
            "fields": {
              "merchantToken": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              },
              "employeesCanViewOwnTimecards": {
                "type": "bool",
                "id": 2,
                "rule": "optional",
                "options": {
                  "default": true
                }
              },
              "employeesCanClockinClockoutFromEmployeeApp": {
                "type": "bool",
                "id": 3,
                "rule": "optional",
                "options": {
                  "default": true
                }
              },
              "useGeofenceForEmployeeClockin": {
                "type": "bool",
                "id": 4,
                "rule": "optional"
              },
              "teamMembersCanSwapShifts": {
                "type": "bool",
                "id": 5,
                "rule": "optional",
                "options": {
                  "default": true
                }
              },
              "teamMembersCanRequestTimeOff": {
                "type": "bool",
                "id": 6,
                "rule": "optional",
                "options": {
                  "default": true
                }
              },
              "teamMembersCanRequestTimecardEdit": {
                "type": "bool",
                "id": 7,
                "rule": "optional",
                "options": {
                  "default": true
                }
              }
            }
          },
          "LocationTimeZone": {
            "fields": {
              "locationToken": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              },
              "timeZone": {
                "type": "string",
                "id": 2,
                "rule": "optional"
              },
              "timeZoneDisplay": {
                "type": "string",
                "id": 3,
                "rule": "optional"
              }
            }
          },
          "LocationBreakSettings": {
            "fields": {
              "token": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              },
              "unitToken": {
                "type": "string",
                "id": 2,
                "rule": "optional"
              },
              "bufferSeconds": {
                "type": "uint32",
                "id": 3,
                "rule": "optional"
              },
              "convertPaidBreakOverageToUnpaid": {
                "type": "bool",
                "id": 4,
                "rule": "optional"
              }
            }
          },
          "LocationTimecardEnforcementSettings": {
            "fields": {
              "id": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              },
              "locationId": {
                "type": "string",
                "id": 2,
                "rule": "optional"
              },
              "earlyClockinBufferDuration": {
                "type": "string",
                "id": 3,
                "rule": "optional"
              },
              "earlyBreakCompletionBufferDuration": {
                "type": "string",
                "id": 4,
                "rule": "optional"
              },
              "convertPaidBreakOverageToUnpaid": {
                "type": "bool",
                "id": 5,
                "rule": "optional"
              },
              "automaticClockoutBufferDuration": {
                "type": "string",
                "id": 6,
                "rule": "optional"
              },
              "geofenceRadiusInMeters": {
                "type": "double",
                "id": 7,
                "rule": "optional"
              },
              "coordinates": {
                "type": "squareup.common.location.Coordinates",
                "id": 8,
                "rule": "optional"
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.timecards?.nested?.Timecard && !$root.nested?.squareup?.nested?.timecards?.nested?.TimecardEvent && !$root.nested?.squareup?.nested?.timecards?.nested?.TimecardEvent?.nested?.EventType && !$root.nested?.squareup?.nested?.timecards?.nested?.TimecardBreak && !$root.nested?.squareup?.nested?.timecards?.nested?.TimecardAndBreaks && !$root.nested?.squareup?.nested?.timecards?.nested?.TimecardBreakEvent && !$root.nested?.squareup?.nested?.timecards?.nested?.TimecardBreakEvent?.nested?.EventType && !$root.nested?.squareup?.nested?.timecards?.nested?.TimecardTransaction && !$root.nested?.squareup?.nested?.timecards?.nested?.TimecardTransaction?.nested?.TeamMember && !$root.nested?.squareup?.nested?.timecards?.nested?.TimecardTransactionWithEvents && !$root.nested?.squareup?.nested?.timecards?.nested?.TimecardBreakDefinition && !$root.nested?.squareup?.nested?.timecards?.nested?.EmployeeJobInfo && !$root.nested?.squareup?.nested?.timecards?.nested?.MerchantUnit && !$root.nested?.squareup?.nested?.timecards?.nested?.Employee && !$root.nested?.squareup?.nested?.timecards?.nested?.EmployeeRole && !$root.nested?.squareup?.nested?.timecards?.nested?.MerchantTimecardAuthorization && !$root.nested?.squareup?.nested?.timecards?.nested?.LocationTimeZone && !$root.nested?.squareup?.nested?.timecards?.nested?.LocationBreakSettings && !$root.nested?.squareup?.nested?.timecards?.nested?.LocationTimecardEnforcementSettings) {
  $root.addJSON(jsonData);
}

/**
 * The offical representation of a timecard at Square.
 *
 * SOURCE Timecard @ squareup/timecards/data.proto at 17:1
 */
export const Timecard = $root.lookupType('squareup.timecards.Timecard');
fixType(Timecard, {
  merchantToken: {
    notEmpty: true
  },
  employeeToken: {
    notEmpty: true
  },
  clockinTimestampMs: {
    required: true
  }
});
Builder.createAndAttachToType(Timecard);
/**
 * Note: employee data will not be point in time
 *
 * SOURCE TimecardEvent @ squareup/timecards/data.proto at 78:1
 */
export const TimecardEvent = $root.lookupType('squareup.timecards.TimecardEvent');
fixType(TimecardEvent, {
  token: {
    notEmpty: true
  },
  eventType: {
    required: true
  },
  pointInTimeTimecard: {
    required: true
  }
});
Builder.createAndAttachToType(TimecardEvent);
/**
 * SOURCE EventType @ squareup/timecards/data.proto at 81:3
 */
TimecardEvent.EventType = $root.lookupEnum('squareup.timecards.TimecardEvent.EventType').values;
/**
 * SOURCE TimecardBreak @ squareup/timecards/data.proto at 115:1
 */
export const TimecardBreak = $root.lookupType('squareup.timecards.TimecardBreak');
fixType(TimecardBreak, {
  merchantToken: {
    notEmpty: true
  },
  timecardBreakDefinitionToken: {
    required: true
  },
  isPaid: {
    required: true
  },
  breakName: {
    required: true
  },
  expectedDurationSeconds: {
    required: true
  },
  startTimestampSeconds: {
    required: true
  }
});
Builder.createAndAttachToType(TimecardBreak);
/**
 * SOURCE TimecardAndBreaks @ squareup/timecards/data.proto at 148:1
 */
export const TimecardAndBreaks = $root.lookupType('squareup.timecards.TimecardAndBreaks');
fixType(TimecardAndBreaks);
Builder.createAndAttachToType(TimecardAndBreaks);
/**
 * SOURCE TimecardBreakEvent @ squareup/timecards/data.proto at 153:1
 */
export const TimecardBreakEvent = $root.lookupType('squareup.timecards.TimecardBreakEvent');
fixType(TimecardBreakEvent, {
  token: {
    notEmpty: true
  },
  breakToken: {
    notEmpty: true
  },
  eventType: {
    required: true
  },
  startTimestampMs: {
    required: true
  },
  timecardBreakDefinitionToken: {
    required: true
  },
  isPaid: {
    required: true
  },
  breakName: {
    required: true
  },
  expectedDurationSeconds: {
    required: true
  }
});
Builder.createAndAttachToType(TimecardBreakEvent);
/**
 * SOURCE EventType @ squareup/timecards/data.proto at 154:3
 */
TimecardBreakEvent.EventType = $root.lookupEnum('squareup.timecards.TimecardBreakEvent.EventType').values;
/**
 * A timecard transaction is used to associate many events that were created in a single action
 * to each other. A timecard transaction also contains useful audit data about who performed
 * the action.
 *
 * For more details: https://docs.google.com/document/d/1wL-iF73xncdSkevy4Zh_9xkmAaBLwIv8qwEwl_UUGbI/edit?usp=sharing
 *
 * SOURCE TimecardTransaction @ squareup/timecards/data.proto at 212:1
 */
export const TimecardTransaction = $root.lookupType('squareup.timecards.TimecardTransaction');
fixType(TimecardTransaction, {
  token: {
    notEmpty: true
  },
  merchantToken: {
    notEmpty: true
  },
  timecardToken: {
    notEmpty: true
  },
  createdAtTimestampMs: {
    required: true
  }
});
Builder.createAndAttachToType(TimecardTransaction);
/**
 * next id: 11
 *
 * SOURCE TeamMember @ squareup/timecards/data.proto at 233:3
 */
TimecardTransaction.TeamMember = $root.lookupType('squareup.timecards.TimecardTransaction.TeamMember');
fixType(TimecardTransaction.TeamMember, {
  id: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(TimecardTransaction.TeamMember);
/**
 * SOURCE TimecardTransactionWithEvents @ squareup/timecards/data.proto at 240:1
 */
export const TimecardTransactionWithEvents = $root.lookupType('squareup.timecards.TimecardTransactionWithEvents');
fixType(TimecardTransactionWithEvents, {
  timecardTransaction: {
    required: true
  }
});
Builder.createAndAttachToType(TimecardTransactionWithEvents);
/**
 * SOURCE TimecardBreakDefinition @ squareup/timecards/data.proto at 246:1
 */
export const TimecardBreakDefinition = $root.lookupType('squareup.timecards.TimecardBreakDefinition');
fixType(TimecardBreakDefinition, {
  merchantToken: {
    notEmpty: true
  },
  unitToken: {
    notEmpty: true
  },
  breakName: {
    notEmpty: true
  },
  expectedDurationSeconds: {
    required: true
  },
  isPaid: {
    required: true
  },
  enabled: {
    required: true
  }
});
Builder.createAndAttachToType(TimecardBreakDefinition);
/**
 * A subset of the employee job data. Typically used as a point in time snapshot. The latest
 * job data can be found in the employeejobs service.
 *
 * SOURCE EmployeeJobInfo @ squareup/timecards/data.proto at 277:1
 */
export const EmployeeJobInfo = $root.lookupType('squareup.timecards.EmployeeJobInfo');
fixType(EmployeeJobInfo);
Builder.createAndAttachToType(EmployeeJobInfo);
/**
 * Represents a location for a merchant with only the minimal information needed for overtime
 * calculations. Unit data is provided by roster.
 *
 * It is possible for many fields to be missing, such as state, country and timezone.
 *
 * If <code>merchant_token == unit_token</code>, then the merchant is *not* a multiunit merchant,
 * and this represents data for the merchant as a whole.
 *
 * SOURCE MerchantUnit @ squareup/timecards/data.proto at 303:1
 */
export const MerchantUnit = $root.lookupType('squareup.timecards.MerchantUnit');
fixType(MerchantUnit, {
  merchantToken: {
    notEmpty: true
  },
  unitToken: {
    notEmpty: true
  },
  tzName: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(MerchantUnit);
/**
 * SOURCE Employee @ squareup/timecards/data.proto at 316:1
 */
export const Employee = $root.lookupType('squareup.timecards.Employee');
fixType(Employee, {
  employeeToken: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(Employee);
/**
 * SOURCE EmployeeRole @ squareup/timecards/data.proto at 328:1
 */
export const EmployeeRole = $root.lookupType('squareup.timecards.EmployeeRole');
fixType(EmployeeRole, {
  employeeRoleToken: {
    notEmpty: true
  },
  name: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(EmployeeRole);
/**
 * Team App settings
 *
 * SOURCE MerchantTimecardAuthorization @ squareup/timecards/data.proto at 336:1
 */
export const MerchantTimecardAuthorization = $root.lookupType('squareup.timecards.MerchantTimecardAuthorization');
fixType(MerchantTimecardAuthorization);
Builder.createAndAttachToType(MerchantTimecardAuthorization);
/**
 * Time Zone information for each unit/location
 *
 * SOURCE LocationTimeZone @ squareup/timecards/data.proto at 355:1
 */
export const LocationTimeZone = $root.lookupType('squareup.timecards.LocationTimeZone');
fixType(LocationTimeZone, {
  timeZone: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(LocationTimeZone);
/**
 * Break settings for a unit.
 *
 * DEPRECATED: this has been replaced by LocationTimecardEnforcementSettings. New settings
 * will no longer be added to this message.
 *
 * SOURCE LocationBreakSettings @ squareup/timecards/data.proto at 371:1
 */
export const LocationBreakSettings = $root.lookupType('squareup.timecards.LocationBreakSettings');
fixType(LocationBreakSettings, {
  token: {
    notEmpty: true
  },
  unitToken: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(LocationBreakSettings);
/**
 * SOURCE LocationTimecardEnforcementSettings @ squareup/timecards/data.proto at 384:1
 */
export const LocationTimecardEnforcementSettings = $root.lookupType('squareup.timecards.LocationTimecardEnforcementSettings');
fixType(LocationTimecardEnforcementSettings, {
  id: {
    notEmpty: true
  },
  locationId: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(LocationTimecardEnforcementSettings);